export default __webpack_public_path__ + "static/naihan-qrx2-2272acd996bf89dc97051e8241c145b4.png";